import {Partner} from './partner/partner';
import {Document} from './document';

export interface Equipment {
  id: number;//
  name: string;//
  equipmentTypeId: number;
  equipmentType?: EquipmentType;
  ownerId: number;//
  owner?: Partner;//
  contactId: number;//
  contact?: Partner;//
  state: string; // Pendiente a cambiar de tipo de dato
  isActive: boolean;//
  documents?: Document[];//
  image?: string;
}

export interface EquipmentCreate {
  "name": string,
  "type": string,
  "state": string,
  "isActive": boolean,
  "ownerId": number,
  "contactId": number
}

export interface EquipmentType {
  id: number;
  name: string;
}
